import script from "./RegionTargetCompletion.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegionTargetCompletion.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__